import clsx from "clsx";
import { Check } from "flowbite-react-icons/outline";
import parse from "html-react-parser";
import PropTypes from "prop-types";

export default function Features({ features, small = false }) {
  let featuresList;

  if (features?.length) {
    featuresList = features.map((feature) => {
      const featureText = parse(feature);
      return (
        <div key={feature} className={clsx("flex flex-row mb-2 items-center", small && "text-sm")}>
          <div className="w-6 h-6 mr-2">
            <Check className="text-success" />
          </div>
          <span>{featureText}</span>
        </div>
      );
    });
  }

  return <div className="flex flex-col h-full">{featuresList}</div>;
}

Features.propTypes = {
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  small: PropTypes.bool,
};
